import * as React from 'react';

/**
 * ACS-1 (ACS-001 AC-6): what someone sees when the email they signed in with is on no roster
 * entry. The API refuses them Pulse's data too; this says why, and who they signed in as.
 */
export function NotOnTeamPanel({ signedInAs }: { readonly signedInAs: string }): React.ReactElement {
  return (
    <section className="card pad stack" style={{ gap: 8, maxWidth: 560 }} role="status">
      <h1 className="display" style={{ fontSize: 32 }}>
        Pulse is for the Ten24 team.
      </h1>
      <span style={{ color: 'var(--ink-2)' }}>You signed in as {signedInAs}. If that should be on the team, ask an admin to add it.</span>
    </section>
  );
}
